export default __webpack_public_path__ + "static/media/mitigation-exterior-excavation-work.dc728cfc.jpg";